export default "assets/images/icons/facebook-bee7c920.svg";